import type { MonthlyTrendEntry } from '../../types/cost-accounting.js';

/** @graph-connects none */
function yen(amount: number): string {
  return `¥${amount.toLocaleString('ja-JP')}`;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business Monthly trend table showing depreciation, disposal, sale, total, and remaining book value across months.
 * @graph-connects none
 */
export function CostAccountingTrendTable({ trend }: { trend: MonthlyTrendEntry[] }) {
  return (
    <div className="mt-6 overflow-x-auto rounded-xl border border-[var(--color-border)]">
      <table className="min-w-full border-collapse text-right text-sm tabular-nums">
        <thead>
          <tr className="bg-[var(--color-bg-subtle,var(--color-bg-base))]">
            <th className="border-b border-[var(--color-border)] px-4 py-2.5 text-left text-xs font-semibold text-[var(--color-text-secondary)]">
              年月
            </th>
            <th className="border-b border-[var(--color-border)] px-4 py-2.5 text-xs font-semibold text-[var(--color-text-secondary)]">
              減価償却費
            </th>
            <th className="border-b border-[var(--color-border)] px-4 py-2.5 text-xs font-semibold text-[var(--color-text-secondary)]">
              廃棄原価
            </th>
            <th className="border-b border-[var(--color-border)] px-4 py-2.5 text-xs font-semibold text-[var(--color-text-secondary)]">
              販売原価
            </th>
            <th className="border-b border-[var(--color-border)] px-4 py-2.5 text-xs font-semibold text-[var(--color-text-secondary)]">
              当月計上合計
            </th>
            <th className="border-b border-[var(--color-border)] px-4 py-2.5 text-xs font-semibold text-[var(--color-text-secondary)]">
              償却残
            </th>
          </tr>
        </thead>
        <tbody>
          {[...trend].reverse().map((row) => (
            <tr key={row.month} className="hover:bg-[var(--color-bg-base)]">
              <td className="border-b border-[var(--color-border)] px-4 py-2 text-left font-mono text-xs text-[var(--color-text-secondary)]">
                {row.month}
              </td>
              <td className="border-b border-[var(--color-border)] px-4 py-2">
                {yen(row.depreciation)}
              </td>
              <td className="border-b border-[var(--color-border)] px-4 py-2">
                {yen(row.disposal)}
              </td>
              <td className="border-b border-[var(--color-border)] px-4 py-2">{yen(row.sale)}</td>
              <td className="border-b border-[var(--color-border)] px-4 py-2 font-semibold">
                {yen(row.total)}
              </td>
              <td className="border-b border-[var(--color-border)] px-4 py-2 font-semibold text-[#1d4ed8]">
                {yen(row.remaining)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
